import { Card, Popover, Typography } from 'antd'
import { RelationSizeParamsSelector } from 'Components'
import { QuestionCircleOutlined } from '@ant-design/icons'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph style={{ width: 500, lineHeight: '1.6rem' }}>
    You can select an attribute key from the list. This will result in resizing all the relations with that attribute key.
  </Paragraph>
</div>)

info = (
  <Popover
    content={helpText}
    title='Size by attribute'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

RelationSizeParamsPanel = ->

  <Card
    title="Size relations by attribute value."
    extra={info}
    size="small"
    id="size-nodes-by-attribute-value"
  >
    <RelationSizeParamsSelector updateConfigNode={true}/>
  </Card>

export default RelationSizeParamsPanel
